
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Profile from '@/src/pages/Profile';
import HeadMeta from '@components/HeadMeta';
import { PROFILE } from '@constants/routes';
import { withNavigation } from '@utils/contentfulHelpers';
import { fetchAllProfileContent } from '@utils/profile';
import { ProfileRootContentType } from '@utils/propTypes';
const DEFAULT_REVALIDATE = Number(process.env.REVALIDATION_TIMEOUT_LONG) || 60 * 5;
const ERROR_REVALIDATE = Number(process.env.REVALIDATION_TIMEOUT_ERROR) || 30;
const propTypes = {
    rootContent: ProfileRootContentType
};
const ProfilePage = ({ rootContent = null }) => {
    return (<>
      <HeadMeta title={'Your Profile'} canonicalUrl={PROFILE}/>
      <Profile path={[]} activeModal={false} pageName="Profile" rootContent={rootContent}/>
    </>);
};
async function getStaticProps() {
    const rootContent = await fetchAllProfileContent();
    const content = [{ contentTypeId: 'profile' }];
    if (!rootContent) {
        return { notFound: true, revalidate: ERROR_REVALIDATE };
    }
    const props = await withNavigation({
        content,
        rootContent
    });
    return {
        props,
        revalidate: DEFAULT_REVALIDATE
    };
}
ProfilePage.propTypes = propTypes;
export default ProfilePage;

    async function __Next_Translate__getStaticProps__195ca0c9553__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/profile/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0c9553__ as getStaticProps }
  